import { VueModule } from '@Foundation';
import MultiPopIn from './code/Scripts/components/multi-pop-in.vue';
export default VueModule({
    components: {
        MultiPopIn
    }
});